import { useEffect, useRef, useState } from 'react';
import { fmt } from '../campaign';

/* claimed-reward popup — white card on a scrim with a count-up amount */
export function ClaimPopup({ trigger, onClose }) {
  const [num, setNum] = useState(0);
  const raf = useRef(null);
  const on = !!trigger;

  useEffect(() => {
    if (!trigger) return undefined;
    setNum(0);
    const t0 = performance.now();
    const up = (now) => {
      const k = Math.min(1, (now - t0) / 900), e = 1 - Math.pow(1 - k, 3);
      const v = trigger.n * e;
      setNum(trigger.decimal ? parseFloat(v.toFixed(4)) : Math.round(v));
      if (k < 1) raf.current = requestAnimationFrame(up);
    };
    raf.current = requestAnimationFrame(up);
    return () => cancelAnimationFrame(raf.current);
  }, [trigger]);

  const display = trigger && trigger.decimal ? num + ' ' + (trigger.unit || 'mg') : fmt(num) + ' ' + (trigger ? trigger.unit : '');

  return (
    <>
      <div className={'gfg-winpop-scrim' + (on ? ' gfg-on' : '')} onClick={onClose} />
      <div className={'gfg-winpop' + (on ? ' gfg-on' : '')} role="dialog" aria-modal="true">
        <div className="gfg-winpop-title">Congratulations!!</div>
        <p className="gfg-winpop-sub">You have earned <b>{display}</b></p>
        {trigger && trigger.label ? <div className="gfg-c">{trigger.label}</div> : null}
        <button className="gfg-cta" onClick={onClose}><span>Done</span></button>
      </div>
    </>
  );
}
